module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table table-hover table-responsive"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.clientState.clients), function(client) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.taxNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.registrationNumber))]), _vm._v(" "), _c('td', {
      staticClass: "shrink-column"
    }, [_c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#client-modal"
      },
      on: {
        "click": function($event) {
          return _vm.edit(client.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(client.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("delete")])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "clientModal",
    staticClass: "modal fade",
    attrs: {
      "id": "client-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Naziv")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.name),
      expression: "currentClient.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Adresa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.address),
      expression: "currentClient.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("PIB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.taxNumber),
      expression: "currentClient.taxNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "taxNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Matični broj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.registrationNumber),
      expression: "currentClient.registrationNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "registrationNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveOrUpdate
    }
  }, [_vm._v("Sačuvaj")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Klijenti")]), _vm._v(" "), _c('p', [_vm._v("Baza firmi sa kojima se sarađuje.")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#client-modal"
    }
  }, [_vm._v("Dodaj klijenta")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Naziv")]), _vm._v(" "), _c('th', [_vm._v("Adresa")]), _vm._v(" "), _c('th', [_vm._v("PIB")]), _vm._v(" "), _c('th', [_vm._v("Matični broj")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Klijent")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2252beb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients.vue
// module id = 291
// module chunks = 1